import * as React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoadingDefault } from '@/components/base/loading';
import { useAuth } from '@/hooks';
import { Helmet } from 'react-helmet';

interface BaseProps {
  children?: React.ReactNode;
}

interface IProps {
  layout?: React.FC<BaseProps>;
  authority?: Authority;
}

export enum Authority {
  GUEST,
  MEMBER,
  ADMIN,
  ROOT,
}

export const wrapperLazyComponent = (
  Element: React.FC<BaseProps>,
  Loading?: React.FC<BaseProps>
) => {
  return (
    <React.Suspense
      fallback={Loading ? <Loading /> : <LoadingDefault sx={{ mt: '-64px' }} />}
    >
      <Element />
    </React.Suspense>
  );
};

export const MainLayoutOutlet = (props: IProps) => {
  const { layout: Layout, authority } = props;
  const { hasLogged } = useAuth();
  const location = useLocation();

  if (authority !== Authority.GUEST && !hasLogged) {
    return (
      <Navigate to="/login" replace state={{ __referrer_from__: location }} />
    );
  }

  const routeHelmet = (
    <Helmet>
      <title>miss</title>
    </Helmet>
  );

  return (
    <>
      {routeHelmet}
      {Layout ? (
        <Layout>
          <Outlet />
        </Layout>
      ) : (
        <Outlet />
      )}
    </>
  );
};
MainLayoutOutlet.defaultProps = {
  authority: Authority.GUEST,
};

export default MainLayoutOutlet;
